import React, {Component} from "react";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import Container from "../../../modules/commons/Container";
import MutasiBarangContent from "./common/mutasiBarangContent";
import {TABS} from "./config";
import {mapToObjectDDL} from "../../common/mapper";
import SimpleDDL from "../../../modules/SimpleDDL";
import FlexView from "react-flexview";
import Api from "../../../Services/Api";

class MutasiBarang extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataCabang: [],
            search: {kodeCabang: null}
        }
    }

    async componentDidMount() {
        await this.fetchDataCabang();
    }

    fetchDataCabang = async () => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang();
            if (res.ok) {
                let filteredData = res.data.data.filter(
                    item => this.props.menuAccess.map(data => data.idRefObj).includes(item.kodeCabang)
                );

                if (filteredData.length !== 0) {
                    this.setState((prevValue) => ({
                        ...prevValue,
                        dataCabang: filteredData,
                        search: {
                            ...prevValue.search,
                            kodeCabang: mapToObjectDDL(filteredData[0].namaDealer, filteredData[0].kodeCabang)
                        }
                    }))
                }
            }
        } catch (error) {
            console.log("errors", error);
        }
    }

    handleSearchValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            search: {
                ...prevValue.search,
                [name]: value,
            },
        }));
    };

    render() {
        return (
            <Container>
                <Tabs>
                    <div>
                        <SimpleDDL
                            id="select_options_kode_cabang"
                            box="search"
                            name="kodeCabang"
                            containerclassname="width width-250px"
                            placeholder="Nama Cabang"
                            menuPosition="fixed"
                            options={
                                this.state.dataCabang.map(
                                    item => mapToObjectDDL(item.namaDealer, item.kodeCabang)
                                )
                            }
                            value={this.state.search.kodeCabang}
                            onChange={(value, {name}) => this.handleSearchValueChange(name, value)}
                        />
                        <TabList>
                            <Tab>Mutasi Keluar</Tab>
                            <Tab>Mutasi Masuk</Tab>
                        </TabList>
                    </div>
                    <TabPanel>
                        <MutasiBarangContent tab={TABS.mutasiKeluar} kodeCabang={this.state.search.kodeCabang}/>
                    </TabPanel>
                    <TabPanel>
                        <MutasiBarangContent tab={TABS.mutasiMasuk} kodeCabang={this.state.search.kodeCabang}/>
                    </TabPanel>
                </Tabs>
            </Container>
        );
    }
}

export default MutasiBarang;
